/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../../common/commonComponents/mediaPreparationTable";

export const getColumns = (t: any): Column[] => [
  {
    header: t("mediaPowder.tableColumns.sl_no"),
    key: "slno",
  },

  {
    header: t("mediaPowder.tableColumns.powder_batch_details"),
    key: "batch_name",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="px-2.5 py-1.5 bg-slate-100 text-slate-900 font-mono font-medium text-[11px] uppercase tracking-wider rounded-md border border-slate-200 shadow-sm">
          {row.batchCode}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPowder.tableColumns.media_name"),
    key: "media_name",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <div className="flex flex-col">
          <span className="font-medium text-slate-800 text-sm tracking-tight whitespace-nowrap">
            {row.name}
          </span>
          <span className="text-[10px] text-slate-400 font-medium mt-0.5 whitespace-nowrap">
            {t("mediaPowder.tableColumns.sku")}: {row.sku}
          </span>
        </div>
      </td>
    ),
  },

  {
    header: t("mediaPowder.tableColumns.manufacturer"),
    key: "manufacturer_name",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-[10px] text-slate-400 font-medium uppercase tracking-widest whitespace-nowrap">
          {row.mf}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPowder.tableColumns.storage"),
    key: "storage",
    render: (row) => (
      <td className="px-6 py-2">
        <span className={`px-3 py-1 rounded-lg text-[11px] font-medium uppercase tracking-widest ${
          row.storage === '2-8°C'
            ? 'bg-blue-50 text-blue-700'
            : 'bg-slate-100 text-slate-700'
        }`}>
          {row.storage}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPowder.tableColumns.stock"),
    key: "stock",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="font-medium text-slate-700 text-sm tracking-tight">
          {row.stock?.toLocaleString()} {row.unit}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPowder.tableColumns.expiry_date"),
    key: "expiry_date",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-sm font-medium text-slate-700 tracking-tight">
          {row.expiry}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPowder.tableColumns.qa_status"),
    key: "qa_release_status",
    render: (row) => {
      const status = row.qaStatus;

      const style =
        status === "Approved" || status === "RELEASED"
          ? "text-emerald-700 bg-emerald-50 border-emerald-100"
          : status === "Rejected"
          ? "text-red-700 bg-red-50 border-red-100"
          : status === "Quarantine"
          ? "text-purple-700 bg-purple-50 border-purple-100"
          : "text-amber-700 bg-amber-50 border-amber-100";

      return (
        <td className="px-6 py-2">
          <span className={`px-3 py-1 rounded-full text-[9px] font-medium uppercase tracking-widest border ${style}`}>
            {status}
          </span>
        </td>
      );
    },
  },
];

